// extracted by mini-css-extract-plugin
export default {"title":"_3f5d0f547f","inner_title":"f954c2bec1","charge_btn":"_88730fc50b"};